module.exports = __webpack_public_path__ + "static/media/icon-score-1-scale-4.361f509f.svg";